module.exports = __webpack_public_path__ + "img/logo2.bf883531.png";